import { render, staticRenderFns } from "./Article_Edit.vue?vue&type=template&id=3e9f908c&scoped=true&"
import script from "./Article_Edit.vue?vue&type=script&lang=js&"
export * from "./Article_Edit.vue?vue&type=script&lang=js&"
import style0 from "./Article_Edit.vue?vue&type=style&index=0&id=3e9f908c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f908c",
  null
  
)

component.options.__file = "Article_Edit.vue"
export default component.exports